import { AnyAction } from 'redux';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { AssessmentPayload } from 'types/assessment-payload';
import { getAssessment } from 'api/api';
import {
  changeSsiDocumentNumberAction,
  fetchAssessmentErrorAction,
  fetchAssessmentStartAction,
  fetchAssessmentSuccessAction,
} from 'actions/assessment';
import { fetchAssessmentSuccessMessages } from 'actions/messages';
import { fetchAssessmentPageAction } from 'actions/assessmentPage';
import { fetchAssessmentSummaryAction } from 'actions/assessmentSummary';
import { GET_ASSESSMENT } from 'actions/assessment/types';
import { SelectedSsiVersion } from 'components/dropdown';
import { RootReducer } from 'store/reducers';
import { CheckMessage, SsiDocument } from '../../types/check';
import { AssessmentReducerType } from '../../store/reducers/assessment';
import { AssessmentPageReducerType } from '../../store/reducers/assessmentPage';

const getAssessmentPage = (state: RootReducer) => state.assessmentPage;
const getAssessmentState = (state: RootReducer) => state.assessment;

const changeTheSelectedDocument = (documentsArray: SsiDocument[], selectedDocument: SelectedSsiVersion) => {
  const documentsNumberArr = documentsArray.map(item => item.documentNumber);
  const documentsProductFamilyArr = documentsArray.map(item => item.productFamily);
  const selectedDocumentProductFamily = selectedDocument.productFamily;
  const matchIndex = documentsProductFamilyArr.indexOf(selectedDocumentProductFamily);
  if (matchIndex !== -1) {
    documentsNumberArr.splice(matchIndex, 1, selectedDocument.value);
  }
  return documentsNumberArr;
};

export function* fetchAssessment({ documentId, documentVersion, ssiDocumentNumber }: AnyAction) {
  let assessmentPayload = undefined;
  let assessmentData: AssessmentReducerType = yield select(getAssessmentState);

  try {
    yield put(fetchAssessmentStartAction());

    const currentSsiDocuments = assessmentData?.assessmentSsiVersions;
    let updatedDocumentNumbers: string[] | undefined;
    if (currentSsiDocuments && currentSsiDocuments.length > 0) {
      updatedDocumentNumbers = changeTheSelectedDocument(currentSsiDocuments, ssiDocumentNumber);
    }

    const ssiDocumentNumbers = updatedDocumentNumbers || ssiDocumentNumber;

    const { data: assessment }: { data: AssessmentPayload } = yield call(getAssessment, documentId, documentVersion, ssiDocumentNumbers);

    const assessmentDocumentNumbers: string[] = assessment.assessmentSsiVersions.map(ssiDetail => ssiDetail.documentNumber as string);
    let documentNumbers: string[] = [];

    if (ssiDocumentNumbers) {
      documentNumbers = ssiDocumentNumbers;
    } else if (assessmentDocumentNumbers.length > 0) {
      documentNumbers = assessmentDocumentNumbers;
    }

    if (documentNumbers) {
      yield put(changeSsiDocumentNumberAction(documentNumbers));
    }

    yield put(fetchAssessmentSuccessAction(assessment));
    yield put(fetchAssessmentSuccessMessages(assessment.messages as CheckMessage[]));

    assessmentPayload = assessment;
  } catch (e) {
    console.error(e);
    yield put(fetchAssessmentErrorAction(e.response?.data?.message, e.response?.status));
  }

  if (assessmentPayload) {
    try {
      let assessmentPage: AssessmentPageReducerType = yield select(getAssessmentPage);
      const selectedPage = assessmentPage?.selectedPage ?? 1;
      yield put(fetchAssessmentPageAction(selectedPage - 1, assessmentPayload.jobToken));
    } catch (e) {
      console.log(e);
    }

    try {
      yield put(fetchAssessmentSummaryAction(assessmentPayload.jobToken));
    } catch (e) {
      console.log(e);
    }
  }
}

export default function* watchFetchAssessment() {
  yield takeEvery(GET_ASSESSMENT, fetchAssessment);
}
